/* eslint-disable */
import Long from "long";
import * as _m0 from "protobufjs/minimal";
import {
  TourOperatorCategory,
  tourOperatorCategoryToNumber,
  tourOperatorCategoryFromJSON,
  tourOperatorCategoryToJSON,
} from "../TourOperator/TourOperator";
import { PriceRange } from "./PriceRange";
import { PopularFilter } from "./PopularFilter";

export interface FilterMeta {
  hasCount: boolean;
  isPotential: boolean;
  count: number;
  price: number;
}

export interface TourOperatorFilter {
  label: string;
  value: string;
  meta?: FilterMeta;
  category: TourOperatorCategory;
}

export interface TourOperatorFilterList {
  itemOrder: string[];
  items: { [key: string]: TourOperatorFilter };
}

export interface TourOperatorFilterList_ItemsEntry {
  key: string;
  value?: TourOperatorFilter;
}

export interface AirlineFilter {
  label: string;
  value: string;
  meta?: FilterMeta;
}

export interface AirlineFilterList {
  itemOrder: string[];
  items: { [key: string]: AirlineFilter };
}

export interface AirlineFilterList_ItemsEntry {
  key: string;
  value?: AirlineFilter;
}

export interface DestinationAirportFilter {
  distance: number;
  label: string;
  value: string;
  meta?: FilterMeta;
}

export interface DestinationAirportFilterList {
  itemOrder: string[];
  items: { [key: string]: DestinationAirportFilter };
}

export interface DestinationAirportFilterList_ItemsEntry {
  key: string;
  value?: DestinationAirportFilter;
}

export interface FlightMeta {
  directFlight?: FilterMeta;
  withNoBag?: FilterMeta;
  airline?: AirlineFilterList;
  hideMixFlights?: FilterMeta;
  destinationAirport?: DestinationAirportFilterList;
}

export interface TransferMeta {
  hotelTransfer?: FilterMeta;
  privateTransfer?: FilterMeta;
  railAndFly?: FilterMeta;
}

export interface AccommodationMeta {
  /** key is MealType enum value (comma separated list for min logic) */
  mealType: { [key: string]: FilterMeta };
  /** key is RoomType enum value */
  roomType: { [key: string]: FilterMeta };
  /** key is RoomClass enum value */
  roomClass: { [key: string]: FilterMeta };
  /** key is ViewType enum value */
  viewType: { [key: string]: FilterMeta };
  /** key is PoolType enum value */
  poolType: { [key: string]: FilterMeta };
  /** key is Exterior enum value */
  exterior: { [key: string]: FilterMeta };
  /** key is HotelCategory value (comma separated list for min logic) */
  hotelCategory: { [key: string]: FilterMeta };
  /** key is Rating value */
  rating: { [key: number]: FilterMeta };
  /** key is AccommodationCategory enum value */
  accommodationCategory: { [key: string]: FilterMeta };
  /** key is Attribute enum value */
  attributes: { [key: string]: FilterMeta };
}

export interface AccommodationMeta_MealTypeEntry {
  key: string;
  value?: FilterMeta;
}

export interface AccommodationMeta_RoomTypeEntry {
  key: string;
  value?: FilterMeta;
}

export interface AccommodationMeta_RoomClassEntry {
  key: string;
  value?: FilterMeta;
}

export interface AccommodationMeta_ViewTypeEntry {
  key: string;
  value?: FilterMeta;
}

export interface AccommodationMeta_PoolTypeEntry {
  key: string;
  value?: FilterMeta;
}

export interface AccommodationMeta_ExteriorEntry {
  key: string;
  value?: FilterMeta;
}

export interface AccommodationMeta_HotelCategoryEntry {
  key: string;
  value?: FilterMeta;
}

export interface AccommodationMeta_RatingEntry {
  key: number;
  value?: FilterMeta;
}

export interface AccommodationMeta_AccommodationCategoryEntry {
  key: string;
  value?: FilterMeta;
}

export interface AccommodationMeta_AttributesEntry {
  key: string;
  value?: FilterMeta;
}

export interface CancellationMeta {
  free?: FilterMeta;
  cost?: FilterMeta;
  free24Hour?: FilterMeta;
}

export interface SpecialMeta {
  cancellation?: CancellationMeta;
  rebookable?: FilterMeta;
  reservable?: FilterMeta;
  lowDeposit?: FilterMeta;
  promoDiscount?: FilterMeta;
}

export interface FilterInformation {
  priceRange?: PriceRange;
  tourOperator?: TourOperatorFilterList;
  flight?: FlightMeta;
  transfer?: TransferMeta;
  accommodation?: AccommodationMeta;
  special?: SpecialMeta;
  popularFilterList: PopularFilter[];
  /** key is TourOperatorCategory enum value */
  tourOperatorCategory: { [key: string]: FilterMeta };
  /** key is PaymentTypeFilter enum value */
  paymentType: { [key: string]: FilterMeta };
}

export interface FilterInformation_TourOperatorCategoryEntry {
  key: string;
  value?: FilterMeta;
}

export interface FilterInformation_PaymentTypeEntry {
  key: string;
  value?: FilterMeta;
}

function createBaseFilterMeta(): FilterMeta {
  return { hasCount: false, isPotential: false, count: 0, price: 0 };
}

export const FilterMeta = {
  encode(
    message: FilterMeta,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.hasCount === true) {
      writer.uint32(24).bool(message.hasCount);
    }
    if (message.isPotential === true) {
      writer.uint32(32).bool(message.isPotential);
    }
    if (message.count !== 0) {
      writer.uint32(8).uint32(message.count);
    }
    if (message.price !== 0) {
      writer.uint32(21).float(message.price);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): FilterMeta {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFilterMeta();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 3:
          message.hasCount = reader.bool();
          break;
        case 4:
          message.isPotential = reader.bool();
          break;
        case 1:
          message.count = reader.uint32();
          break;
        case 2:
          message.price = reader.float();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): FilterMeta {
    return {
      hasCount: isSet(object.hasCount) ? Boolean(object.hasCount) : false,
      isPotential: isSet(object.isPotential)
        ? Boolean(object.isPotential)
        : false,
      count: isSet(object.count) ? Number(object.count) : 0,
      price: isSet(object.price) ? Number(object.price) : 0,
    };
  },

  toJSON(message: FilterMeta): unknown {
    const obj: any = {};
    message.hasCount !== undefined && (obj.hasCount = message.hasCount);
    message.isPotential !== undefined &&
      (obj.isPotential = message.isPotential);
    message.count !== undefined && (obj.count = Math.round(message.count));
    message.price !== undefined && (obj.price = message.price);
    return obj;
  },

  fromPartial(object: DeepPartial<FilterMeta>): FilterMeta {
    const message = createBaseFilterMeta();
    message.hasCount = object.hasCount ?? false;
    message.isPotential = object.isPotential ?? false;
    message.count = object.count ?? 0;
    message.price = object.price ?? 0;
    return message;
  },
};

function createBaseTourOperatorFilter(): TourOperatorFilter {
  return {
    label: "",
    value: "",
    meta: undefined,
    category: TourOperatorCategory.Classic,
  };
}

export const TourOperatorFilter = {
  encode(
    message: TourOperatorFilter,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.label !== "") {
      writer.uint32(10).string(message.label);
    }
    if (message.value !== "") {
      writer.uint32(18).string(message.value);
    }
    if (message.meta !== undefined) {
      FilterMeta.encode(message.meta, writer.uint32(26).fork()).ldelim();
    }
    if (message.category !== TourOperatorCategory.Classic) {
      writer.uint32(32).int32(tourOperatorCategoryToNumber(message.category));
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TourOperatorFilter {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTourOperatorFilter();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.label = reader.string();
          break;
        case 2:
          message.value = reader.string();
          break;
        case 3:
          message.meta = FilterMeta.decode(reader, reader.uint32());
          break;
        case 4:
          message.category = tourOperatorCategoryFromJSON(reader.int32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): TourOperatorFilter {
    return {
      label: isSet(object.label) ? String(object.label) : "",
      value: isSet(object.value) ? String(object.value) : "",
      meta: isSet(object.meta) ? FilterMeta.fromJSON(object.meta) : undefined,
      category: isSet(object.category)
        ? tourOperatorCategoryFromJSON(object.category)
        : TourOperatorCategory.Classic,
    };
  },

  toJSON(message: TourOperatorFilter): unknown {
    const obj: any = {};
    message.label !== undefined && (obj.label = message.label);
    message.value !== undefined && (obj.value = message.value);
    message.meta !== undefined &&
      (obj.meta = message.meta ? FilterMeta.toJSON(message.meta) : undefined);
    message.category !== undefined &&
      (obj.category = tourOperatorCategoryToJSON(message.category));
    return obj;
  },

  fromPartial(object: DeepPartial<TourOperatorFilter>): TourOperatorFilter {
    const message = createBaseTourOperatorFilter();
    message.label = object.label ?? "";
    message.value = object.value ?? "";
    message.meta =
      object.meta !== undefined && object.meta !== null
        ? FilterMeta.fromPartial(object.meta)
        : undefined;
    message.category = object.category ?? TourOperatorCategory.Classic;
    return message;
  },
};

function createBaseTourOperatorFilterList(): TourOperatorFilterList {
  return { itemOrder: [], items: {} };
}

export const TourOperatorFilterList = {
  encode(
    message: TourOperatorFilterList,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    for (const v of message.itemOrder) {
      writer.uint32(18).string(v!);
    }
    Object.entries(message.items).forEach(([key, value]) => {
      TourOperatorFilterList_ItemsEntry.encode(
        { key: key as any, value },
        writer.uint32(10).fork()
      ).ldelim();
    });
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number
  ): TourOperatorFilterList {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTourOperatorFilterList();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2:
          message.itemOrder.push(reader.string());
          break;
        case 1:
          const entry1 = TourOperatorFilterList_ItemsEntry.decode(
            reader,
            reader.uint32()
          );
          if (entry1.value !== undefined) {
            message.items[entry1.key] = entry1.value;
          }
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): TourOperatorFilterList {
    return {
      itemOrder: Array.isArray(object?.itemOrder)
        ? object.itemOrder.map((e: any) => String(e))
        : [],
      items: isObject(object.items)
        ? Object.entries(object.items).reduce<{
            [key: string]: TourOperatorFilter;
          }>((acc, [key, value]) => {
            acc[key] = TourOperatorFilter.fromJSON(value);
            return acc;
          }, {})
        : {},
    };
  },

  toJSON(message: TourOperatorFilterList): unknown {
    const obj: any = {};
    if (message.itemOrder) {
      obj.itemOrder = message.itemOrder.map((e) => e);
    } else {
      obj.itemOrder = [];
    }
    obj.items = {};
    if (message.items) {
      Object.entries(message.items).forEach(([k, v]) => {
        obj.items[k] = TourOperatorFilter.toJSON(v);
      });
    }
    return obj;
  },

  fromPartial(
    object: DeepPartial<TourOperatorFilterList>
  ): TourOperatorFilterList {
    const message = createBaseTourOperatorFilterList();
    message.itemOrder = object.itemOrder?.map((e) => e) || [];
    message.items = Object.entries(object.items ?? {}).reduce<{
      [key: string]: TourOperatorFilter;
    }>((acc, [key, value]) => {
      if (value !== undefined) {
        acc[key] = TourOperatorFilter.fromPartial(value);
      }
      return acc;
    }, {});
    return message;
  },
};

function createBaseTourOperatorFilterList_ItemsEntry(): TourOperatorFilterList_ItemsEntry {
  return { key: "", value: undefined };
}

export const TourOperatorFilterList_ItemsEntry = {
  encode(
    message: TourOperatorFilterList_ItemsEntry,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      TourOperatorFilter.encode(
        message.value,
        writer.uint32(18).fork()
      ).ldelim();
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number
  ): TourOperatorFilterList_ItemsEntry {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTourOperatorFilterList_ItemsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.key = reader.string();
          break;
        case 2:
          message.value = TourOperatorFilter.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): TourOperatorFilterList_ItemsEntry {
    return {
      key: isSet(object.key) ? String(object.key) : "",
      value: isSet(object.value)
        ? TourOperatorFilter.fromJSON(object.value)
        : undefined,
    };
  },

  toJSON(message: TourOperatorFilterList_ItemsEntry): unknown {
    const obj: any = {};
    message.key !== undefined && (obj.key = message.key);
    message.value !== undefined &&
      (obj.value = message.value
        ? TourOperatorFilter.toJSON(message.value)
        : undefined);
    return obj;
  },

  fromPartial(
    object: DeepPartial<TourOperatorFilterList_ItemsEntry>
  ): TourOperatorFilterList_ItemsEntry {
    const message = createBaseTourOperatorFilterList_ItemsEntry();
    message.key = object.key ?? "";
    message.value =
      object.value !== undefined && object.value !== null
        ? TourOperatorFilter.fromPartial(object.value)
        : undefined;
    return message;
  },
};

function createBaseAirlineFilter(): AirlineFilter {
  return { label: "", value: "", meta: undefined };
}

export const AirlineFilter = {
  encode(
    message: AirlineFilter,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.label !== "") {
      writer.uint32(10).string(message.label);
    }
    if (message.value !== "") {
      writer.uint32(18).string(message.value);
    }
    if (message.meta !== undefined) {
      FilterMeta.encode(message.meta, writer.uint32(26).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AirlineFilter {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAirlineFilter();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.label = reader.string();
          break;
        case 2:
          message.value = reader.string();
          break;
        case 3:
          message.meta = FilterMeta.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): AirlineFilter {
    return {
      label: isSet(object.label) ? String(object.label) : "",
      value: isSet(object.value) ? String(object.value) : "",
      meta: isSet(object.meta) ? FilterMeta.fromJSON(object.meta) : undefined,
    };
  },

  toJSON(message: AirlineFilter): unknown {
    const obj: any = {};
    message.label !== undefined && (obj.label = message.label);
    message.value !== undefined && (obj.value = message.value);
    message.meta !== undefined &&
      (obj.meta = message.meta ? FilterMeta.toJSON(message.meta) : undefined);
    return obj;
  },

  fromPartial(object: DeepPartial<AirlineFilter>): AirlineFilter {
    const message = createBaseAirlineFilter();
    message.label = object.label ?? "";
    message.value = object.value ?? "";
    message.meta =
      object.meta !== undefined && object.meta !== null
        ? FilterMeta.fromPartial(object.meta)
        : undefined;
    return message;
  },
};

function createBaseAirlineFilterList(): AirlineFilterList {
  return { itemOrder: [], items: {} };
}

export const AirlineFilterList = {
  encode(
    message: AirlineFilterList,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    for (const v of message.itemOrder) {
      writer.uint32(18).string(v!);
    }
    Object.entries(message.items).forEach(([key, value]) => {
      AirlineFilterList_ItemsEntry.encode(
        { key: key as any, value },
        writer.uint32(10).fork()
      ).ldelim();
    });
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AirlineFilterList {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAirlineFilterList();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2:
          message.itemOrder.push(reader.string());
          break;
        case 1:
          const entry1 = AirlineFilterList_ItemsEntry.decode(
            reader,
            reader.uint32()
          );
          if (entry1.value !== undefined) {
            message.items[entry1.key] = entry1.value;
          }
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): AirlineFilterList {
    return {
      itemOrder: Array.isArray(object?.itemOrder)
        ? object.itemOrder.map((e: any) => String(e))
        : [],
      items: isObject(object.items)
        ? Object.entries(object.items).reduce<{ [key: string]: AirlineFilter }>(
            (acc, [key, value]) => {
              acc[key] = AirlineFilter.fromJSON(value);
              return acc;
            },
            {}
          )
        : {},
    };
  },

  toJSON(message: AirlineFilterList): unknown {
    const obj: any = {};
    if (message.itemOrder) {
      obj.itemOrder = message.itemOrder.map((e) => e);
    } else {
      obj.itemOrder = [];
    }
    obj.items = {};
    if (message.items) {
      Object.entries(message.items).forEach(([k, v]) => {
        obj.items[k] = AirlineFilter.toJSON(v);
      });
    }
    return obj;
  },

  fromPartial(object: DeepPartial<AirlineFilterList>): AirlineFilterList {
    const message = createBaseAirlineFilterList();
    message.itemOrder = object.itemOrder?.map((e) => e) || [];
    message.items = Object.entries(object.items ?? {}).reduce<{
      [key: string]: AirlineFilter;
    }>((acc, [key, value]) => {
      if (value !== undefined) {
        acc[key] = AirlineFilter.fromPartial(value);
      }
      return acc;
    }, {});
    return message;
  },
};

function createBaseAirlineFilterList_ItemsEntry(): AirlineFilterList_ItemsEntry {
  return { key: "", value: undefined };
}

export const AirlineFilterList_ItemsEntry = {
  encode(
    message: AirlineFilterList_ItemsEntry,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      AirlineFilter.encode(message.value, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number
  ): AirlineFilterList_ItemsEntry {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAirlineFilterList_ItemsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.key = reader.string();
          break;
        case 2:
          message.value = AirlineFilter.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): AirlineFilterList_ItemsEntry {
    return {
      key: isSet(object.key) ? String(object.key) : "",
      value: isSet(object.value)
        ? AirlineFilter.fromJSON(object.value)
        : undefined,
    };
  },

  toJSON(message: AirlineFilterList_ItemsEntry): unknown {
    const obj: any = {};
    message.key !== undefined && (obj.key = message.key);
    message.value !== undefined &&
      (obj.value = message.value
        ? AirlineFilter.toJSON(message.value)
        : undefined);
    return obj;
  },

  fromPartial(
    object: DeepPartial<AirlineFilterList_ItemsEntry>
  ): AirlineFilterList_ItemsEntry {
    const message = createBaseAirlineFilterList_ItemsEntry();
    message.key = object.key ?? "";
    message.value =
      object.value !== undefined && object.value !== null
        ? AirlineFilter.fromPartial(object.value)
        : undefined;
    return message;
  },
};

function createBaseDestinationAirportFilter(): DestinationAirportFilter {
  return { distance: 0, label: "", value: "", meta: undefined };
}

export const DestinationAirportFilter = {
  encode(
    message: DestinationAirportFilter,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.distance !== 0) {
      writer.uint32(32).uint32(message.distance);
    }
    if (message.label !== "") {
      writer.uint32(10).string(message.label);
    }
    if (message.value !== "") {
      writer.uint32(18).string(message.value);
    }
    if (message.meta !== undefined) {
      FilterMeta.encode(message.meta, writer.uint32(26).fork()).ldelim();
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number
  ): DestinationAirportFilter {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDestinationAirportFilter();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 4:
          message.distance = reader.uint32();
          break;
        case 1:
          message.label = reader.string();
          break;
        case 2:
          message.value = reader.string();
          break;
        case 3:
          message.meta = FilterMeta.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): DestinationAirportFilter {
    return {
      distance: isSet(object.distance) ? Number(object.distance) : 0,
      label: isSet(object.label) ? String(object.label) : "",
      value: isSet(object.value) ? String(object.value) : "",
      meta: isSet(object.meta) ? FilterMeta.fromJSON(object.meta) : undefined,
    };
  },

  toJSON(message: DestinationAirportFilter): unknown {
    const obj: any = {};
    message.distance !== undefined &&
      (obj.distance = Math.round(message.distance));
    message.label !== undefined && (obj.label = message.label);
    message.value !== undefined && (obj.value = message.value);
    message.meta !== undefined &&
      (obj.meta = message.meta ? FilterMeta.toJSON(message.meta) : undefined);
    return obj;
  },

  fromPartial(
    object: DeepPartial<DestinationAirportFilter>
  ): DestinationAirportFilter {
    const message = createBaseDestinationAirportFilter();
    message.distance = object.distance ?? 0;
    message.label = object.label ?? "";
    message.value = object.value ?? "";
    message.meta =
      object.meta !== undefined && object.meta !== null
        ? FilterMeta.fromPartial(object.meta)
        : undefined;
    return message;
  },
};

function createBaseDestinationAirportFilterList(): DestinationAirportFilterList {
  return { itemOrder: [], items: {} };
}

export const DestinationAirportFilterList = {
  encode(
    message: DestinationAirportFilterList,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    for (const v of message.itemOrder) {
      writer.uint32(18).string(v!);
    }
    Object.entries(message.items).forEach(([key, value]) => {
      DestinationAirportFilterList_ItemsEntry.encode(
        { key: key as any, value },
        writer.uint32(10).fork()
      ).ldelim();
    });
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number
  ): DestinationAirportFilterList {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDestinationAirportFilterList();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2:
          message.itemOrder.push(reader.string());
          break;
        case 1:
          const entry1 = DestinationAirportFilterList_ItemsEntry.decode(
            reader,
            reader.uint32()
          );
          if (entry1.value !== undefined) {
            message.items[entry1.key] = entry1.value;
          }
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): DestinationAirportFilterList {
    return {
      itemOrder: Array.isArray(object?.itemOrder)
        ? object.itemOrder.map((e: any) => String(e))
        : [],
      items: isObject(object.items)
        ? Object.entries(object.items).reduce<{
            [key: string]: DestinationAirportFilter;
          }>((acc, [key, value]) => {
            acc[key] = DestinationAirportFilter.fromJSON(value);
            return acc;
          }, {})
        : {},
    };
  },

  toJSON(message: DestinationAirportFilterList): unknown {
    const obj: any = {};
    if (message.itemOrder) {
      obj.itemOrder = message.itemOrder.map((e) => e);
    } else {
      obj.itemOrder = [];
    }
    obj.items = {};
    if (message.items) {
      Object.entries(message.items).forEach(([k, v]) => {
        obj.items[k] = DestinationAirportFilter.toJSON(v);
      });
    }
    return obj;
  },

  fromPartial(
    object: DeepPartial<DestinationAirportFilterList>
  ): DestinationAirportFilterList {
    const message = createBaseDestinationAirportFilterList();
    message.itemOrder = object.itemOrder?.map((e) => e) || [];
    message.items = Object.entries(object.items ?? {}).reduce<{
      [key: string]: DestinationAirportFilter;
    }>((acc, [key, value]) => {
      if (value !== undefined) {
        acc[key] = DestinationAirportFilter.fromPartial(value);
      }
      return acc;
    }, {});
    return message;
  },
};

function createBaseDestinationAirportFilterList_ItemsEntry(): DestinationAirportFilterList_ItemsEntry {
  return { key: "", value: undefined };
}

export const DestinationAirportFilterList_ItemsEntry = {
  encode(
    message: DestinationAirportFilterList_ItemsEntry,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      DestinationAirportFilter.encode(
        message.value,
        writer.uint32(18).fork()
      ).ldelim();
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number
  ): DestinationAirportFilterList_ItemsEntry {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDestinationAirportFilterList_ItemsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.key = reader.string();
          break;
        case 2:
          message.value = DestinationAirportFilter.decode(
            reader,
            reader.uint32()
          );
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): DestinationAirportFilterList_ItemsEntry {
    return {
      key: isSet(object.key) ? String(object.key) : "",
      value: isSet(object.value)
        ? DestinationAirportFilter.fromJSON(object.value)
        : undefined,
    };
  },

  toJSON(message: DestinationAirportFilterList_ItemsEntry): unknown {
    const obj: any = {};
    message.key !== undefined && (obj.key = message.key);
    message.value !== undefined &&
      (obj.value = message.value
        ? DestinationAirportFilter.toJSON(message.value)
        : undefined);
    return obj;
  },

  fromPartial(
    object: DeepPartial<DestinationAirportFilterList_ItemsEntry>
  ): DestinationAirportFilterList_ItemsEntry {
    const message = createBaseDestinationAirportFilterList_ItemsEntry();
    message.key = object.key ?? "";
    message.value =
      object.value !== undefined && object.value !== null
        ? DestinationAirportFilter.fromPartial(object.value)
        : undefined;
    return message;
  },
};

function createBaseFlightMeta(): FlightMeta {
  return {
    directFlight: undefined,
    withNoBag: undefined,
    airline: undefined,
    hideMixFlights: undefined,
    destinationAirport: undefined,
  };
}

export const FlightMeta = {
  encode(
    message: FlightMeta,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.directFlight !== undefined) {
      FilterMeta.encode(
        message.directFlight,
        writer.uint32(10).fork()
      ).ldelim();
    }
    if (message.withNoBag !== undefined) {
      FilterMeta.encode(message.withNoBag, writer.uint32(18).fork()).ldelim();
    }
    if (message.airline !== undefined) {
      AirlineFilterList.encode(
        message.airline,
        writer.uint32(26).fork()
      ).ldelim();
    }
    if (message.hideMixFlights !== undefined) {
      FilterMeta.encode(
        message.hideMixFlights,
        writer.uint32(34).fork()
      ).ldelim();
    }
    if (message.destinationAirport !== undefined) {
      DestinationAirportFilterList.encode(
        message.destinationAirport,
        writer.uint32(42).fork()
      ).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): FlightMeta {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFlightMeta();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.directFlight = FilterMeta.decode(reader, reader.uint32());
          break;
        case 2:
          message.withNoBag = FilterMeta.decode(reader, reader.uint32());
          break;
        case 3:
          message.airline = AirlineFilterList.decode(reader, reader.uint32());
          break;
        case 4:
          message.hideMixFlights = FilterMeta.decode(reader, reader.uint32());
          break;
        case 5:
          message.destinationAirport = DestinationAirportFilterList.decode(
            reader,
            reader.uint32()
          );
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): FlightMeta {
    return {
      directFlight: isSet(object.directFlight)
        ? FilterMeta.fromJSON(object.directFlight)
        : undefined,
      withNoBag: isSet(object.withNoBag)
        ? FilterMeta.fromJSON(object.withNoBag)
        : undefined,
      airline: isSet(object.airline)
        ? AirlineFilterList.fromJSON(object.airline)
        : undefined,
      hideMixFlights: isSet(object.hideMixFlights)
        ? FilterMeta.fromJSON(object.hideMixFlights)
        : undefined,
      destinationAirport: isSet(object.destinationAirport)
        ? DestinationAirportFilterList.fromJSON(object.destinationAirport)
        : undefined,
    };
  },

  toJSON(message: FlightMeta): unknown {
    const obj: any = {};
    message.directFlight !== undefined &&
      (obj.directFlight = message.directFlight
        ? FilterMeta.toJSON(message.directFlight)
        : undefined);
    message.withNoBag !== undefined &&
      (obj.withNoBag = message.withNoBag
        ? FilterMeta.toJSON(message.withNoBag)
        : undefined);
    message.airline !== undefined &&
      (obj.airline = message.airline
        ? AirlineFilterList.toJSON(message.airline)
        : undefined);
    message.hideMixFlights !== undefined &&
      (obj.hideMixFlights = message.hideMixFlights
        ? FilterMeta.toJSON(message.hideMixFlights)
        : undefined);
    message.destinationAirport !== undefined &&
      (obj.destinationAirport = message.destinationAirport
        ? DestinationAirportFilterList.toJSON(message.destinationAirport)
        : undefined);
    return obj;
  },

  fromPartial(object: DeepPartial<FlightMeta>): FlightMeta {
    const message = createBaseFlightMeta();
    message.directFlight =
      object.directFlight !== undefined && object.directFlight !== null
        ? FilterMeta.fromPartial(object.directFlight)
        : undefined;
    message.withNoBag =
      object.withNoBag !== undefined && object.withNoBag !== null
        ? FilterMeta.fromPartial(object.withNoBag)
        : undefined;
    message.airline =
      object.airline !== undefined && object.airline !== null
        ? AirlineFilterList.fromPartial(object.airline)
        : undefined;
    message.hideMixFlights =
      object.hideMixFlights !== undefined && object.hideMixFlights !== null
        ? FilterMeta.fromPartial(object.hideMixFlights)
        : undefined;
    message.destinationAirport =
      object.destinationAirport !== undefined &&
      object.destinationAirport !== null
        ? DestinationAirportFilterList.fromPartial(object.destinationAirport)
        : undefined;
    return message;
  },
};

function createBaseTransferMeta(): TransferMeta {
  return {
    hotelTransfer: undefined,
    privateTransfer: undefined,
    railAndFly: undefined,
  };
}

export const TransferMeta = {
  encode(
    message: TransferMeta,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.hotelTransfer !== undefined) {
      FilterMeta.encode(
        message.hotelTransfer,
        writer.uint32(10).fork()
      ).ldelim();
    }
    if (message.privateTransfer !== undefined) {
      FilterMeta.encode(
        message.privateTransfer,
        writer.uint32(18).fork()
      ).ldelim();
    }
    if (message.railAndFly !== undefined) {
      FilterMeta.encode(message.railAndFly, writer.uint32(26).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TransferMeta {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTransferMeta();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.hotelTransfer = FilterMeta.decode(reader, reader.uint32());
          break;
        case 2:
          message.privateTransfer = FilterMeta.decode(reader, reader.uint32());
          break;
        case 3:
          message.railAndFly = FilterMeta.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): TransferMeta {
    return {
      hotelTransfer: isSet(object.hotelTransfer)
        ? FilterMeta.fromJSON(object.hotelTransfer)
        : undefined,
      privateTransfer: isSet(object.privateTransfer)
        ? FilterMeta.fromJSON(object.privateTransfer)
        : undefined,
      railAndFly: isSet(object.railAndFly)
        ? FilterMeta.fromJSON(object.railAndFly)
        : undefined,
    };
  },

  toJSON(message: TransferMeta): unknown {
    const obj: any = {};
    message.hotelTransfer !== undefined &&
      (obj.hotelTransfer = message.hotelTransfer
        ? FilterMeta.toJSON(message.hotelTransfer)
        : undefined);
    message.privateTransfer !== undefined &&
      (obj.privateTransfer = message.privateTransfer
        ? FilterMeta.toJSON(message.privateTransfer)
        : undefined);
    message.railAndFly !== undefined &&
      (obj.railAndFly = message.railAndFly
        ? FilterMeta.toJSON(message.railAndFly)
        : undefined);
    return obj;
  },

  fromPartial(object: DeepPartial<TransferMeta>): TransferMeta {
    const message = createBaseTransferMeta();
    message.hotelTransfer =
      object.hotelTransfer !== undefined && object.hotelTransfer !== null
        ? FilterMeta.fromPartial(object.hotelTransfer)
        : undefined;
    message.privateTransfer =
      object.privateTransfer !== undefined && object.privateTransfer !== null
        ? FilterMeta.fromPartial(object.privateTransfer)
        : undefined;
    message.railAndFly =
      object.railAndFly !== undefined && object.railAndFly !== null
        ? FilterMeta.fromPartial(object.railAndFly)
        : undefined;
    return message;
  },
};

function createBaseAccommodationMeta(): AccommodationMeta {
  return {
    mealType: {},
    roomType: {},
    roomClass: {},
    viewType: {},
    poolType: {},
    exterior: {},
    hotelCategory: {},
    rating: {},
    accommodationCategory: {},
    attributes: {},
  };
}

export const AccommodationMeta = {
  encode(
    message: AccommodationMeta,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    Object.entries(message.mealType).forEach(([key, value]) => {
      AccommodationMeta_MealTypeEntry.encode(
        { key: key as any, value },
        writer.uint32(10).fork()
      ).ldelim();
    });
    Object.entries(message.roomType).forEach(([key, value]) => {
      AccommodationMeta_RoomTypeEntry.encode(
        { key: key as any, value },
        writer.uint32(18).fork()
      ).ldelim();
    });
    Object.entries(message.roomClass).forEach(([key, value]) => {
      AccommodationMeta_RoomClassEntry.encode(
        { key: key as any, value },
        writer.uint32(26).fork()
      ).ldelim();
    });
    Object.entries(message.viewType).forEach(([key, value]) => {
      AccommodationMeta_ViewTypeEntry.encode(
        { key: key as any, value },
        writer.uint32(34).fork()
      ).ldelim();
    });
    Object.entries(message.poolType).forEach(([key, value]) => {
      AccommodationMeta_PoolTypeEntry.encode(
        { key: key as any, value },
        writer.uint32(42).fork()
      ).ldelim();
    });
    Object.entries(message.exterior).forEach(([key, value]) => {
      AccommodationMeta_ExteriorEntry.encode(
        { key: key as any, value },
        writer.uint32(50).fork()
      ).ldelim();
    });
    Object.entries(message.hotelCategory).forEach(([key, value]) => {
      AccommodationMeta_HotelCategoryEntry.encode(
        { key: key as any, value },
        writer.uint32(58).fork()
      ).ldelim();
    });
    Object.entries(message.rating).forEach(([key, value]) => {
      AccommodationMeta_RatingEntry.encode(
        { key: key as any, value },
        writer.uint32(66).fork()
      ).ldelim();
    });
    Object.entries(message.accommodationCategory).forEach(([key, value]) => {
      AccommodationMeta_AccommodationCategoryEntry.encode(
        { key: key as any, value },
        writer.uint32(74).fork()
      ).ldelim();
    });
    Object.entries(message.attributes).forEach(([key, value]) => {
      AccommodationMeta_AttributesEntry.encode(
        { key: key as any, value },
        writer.uint32(82).fork()
      ).ldelim();
    });
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AccommodationMeta {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAccommodationMeta();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          const entry1 = AccommodationMeta_MealTypeEntry.decode(
            reader,
            reader.uint32()
          );
          if (entry1.value !== undefined) {
            message.mealType[entry1.key] = entry1.value;
          }
          break;
        case 2:
          const entry2 = AccommodationMeta_RoomTypeEntry.decode(
            reader,
            reader.uint32()
          );
          if (entry2.value !== undefined) {
            message.roomType[entry2.key] = entry2.value;
          }
          break;
        case 3:
          const entry3 = AccommodationMeta_RoomClassEntry.decode(
            reader,
            reader.uint32()
          );
          if (entry3.value !== undefined) {
            message.roomClass[entry3.key] = entry3.value;
          }
          break;
        case 4:
          const entry4 = AccommodationMeta_ViewTypeEntry.decode(
            reader,
            reader.uint32()
          );
          if (entry4.value !== undefined) {
            message.viewType[entry4.key] = entry4.value;
          }
          break;
        case 5:
          const entry5 = AccommodationMeta_PoolTypeEntry.decode(
            reader,
            reader.uint32()
          );
          if (entry5.value !== undefined) {
            message.poolType[entry5.key] = entry5.value;
          }
          break;
        case 6:
          const entry6 = AccommodationMeta_ExteriorEntry.decode(
            reader,
            reader.uint32()
          );
          if (entry6.value !== undefined) {
            message.exterior[entry6.key] = entry6.value;
          }
          break;
        case 7:
          const entry7 = AccommodationMeta_HotelCategoryEntry.decode(
            reader,
            reader.uint32()
          );
          if (entry7.value !== undefined) {
            message.hotelCategory[entry7.key] = entry7.value;
          }
          break;
        case 8:
          const entry8 = AccommodationMeta_RatingEntry.decode(
            reader,
            reader.uint32()
          );
          if (entry8.value !== undefined) {
            message.rating[entry8.key] = entry8.value;
          }
          break;
        case 9:
          const entry9 = AccommodationMeta_AccommodationCategoryEntry.decode(
            reader,
            reader.uint32()
          );
          if (entry9.value !== undefined) {
            message.accommodationCategory[entry9.key] = entry9.value;
          }
          break;
        case 10:
          const entry10 = AccommodationMeta_AttributesEntry.decode(
            reader,
            reader.uint32()
          );
          if (entry10.value !== undefined) {
            message.attributes[entry10.key] = entry10.value;
          }
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): AccommodationMeta {
    return {
      mealType: isObject(object.mealType)
        ? Object.entries(object.mealType).reduce<{ [key: string]: FilterMeta }>(
            (acc, [key, value]) => {
              acc[key] = FilterMeta.fromJSON(value);
              return acc;
            },
            {}
          )
        : {},
      roomType: isObject(object.roomType)
        ? Object.entries(object.roomType).reduce<{ [key: string]: FilterMeta }>(
            (acc, [key, value]) => {
              acc[key] = FilterMeta.fromJSON(value);
              return acc;
            },
            {}
          )
        : {},
      roomClass: isObject(object.roomClass)
        ? Object.entries(object.roomClass).reduce<{
            [key: string]: FilterMeta;
          }>((acc, [key, value]) => {
            acc[key] = FilterMeta.fromJSON(value);
            return acc;
          }, {})
        : {},
      viewType: isObject(object.viewType)
        ? Object.entries(object.viewType).reduce<{ [key: string]: FilterMeta }>(
            (acc, [key, value]) => {
              acc[key] = FilterMeta.fromJSON(value);
              return acc;
            },
            {}
          )
        : {},
      poolType: isObject(object.poolType)
        ? Object.entries(object.poolType).reduce<{ [key: string]: FilterMeta }>(
            (acc, [key, value]) => {
              acc[key] = FilterMeta.fromJSON(value);
              return acc;
            },
            {}
          )
        : {},
      exterior: isObject(object.exterior)
        ? Object.entries(object.exterior).reduce<{ [key: string]: FilterMeta }>(
            (acc, [key, value]) => {
              acc[key] = FilterMeta.fromJSON(value);
              return acc;
            },
            {}
          )
        : {},
      hotelCategory: isObject(object.hotelCategory)
        ? Object.entries(object.hotelCategory).reduce<{
            [key: string]: FilterMeta;
          }>((acc, [key, value]) => {
            acc[key] = FilterMeta.fromJSON(value);
            return acc;
          }, {})
        : {},
      rating: isObject(object.rating)
        ? Object.entries(object.rating).reduce<{ [key: number]: FilterMeta }>(
            (acc, [key, value]) => {
              acc[Number(key)] = FilterMeta.fromJSON(value);
              return acc;
            },
            {}
          )
        : {},
      accommodationCategory: isObject(object.accommodationCategory)
        ? Object.entries(object.accommodationCategory).reduce<{
            [key: string]: FilterMeta;
          }>((acc, [key, value]) => {
            acc[key] = FilterMeta.fromJSON(value);
            return acc;
          }, {})
        : {},
      attributes: isObject(object.attributes)
        ? Object.entries(object.attributes).reduce<{
            [key: string]: FilterMeta;
          }>((acc, [key, value]) => {
            acc[key] = FilterMeta.fromJSON(value);
            return acc;
          }, {})
        : {},
    };
  },

  toJSON(message: AccommodationMeta): unknown {
    const obj: any = {};
    obj.mealType = {};
    if (message.mealType) {
      Object.entries(message.mealType).forEach(([k, v]) => {
        obj.mealType[k] = FilterMeta.toJSON(v);
      });
    }
    obj.roomType = {};
    if (message.roomType) {
      Object.entries(message.roomType).forEach(([k, v]) => {
        obj.roomType[k] = FilterMeta.toJSON(v);
      });
    }
    obj.roomClass = {};
    if (message.roomClass) {
      Object.entries(message.roomClass).forEach(([k, v]) => {
        obj.roomClass[k] = FilterMeta.toJSON(v);
      });
    }
    obj.viewType = {};
    if (message.viewType) {
      Object.entries(message.viewType).forEach(([k, v]) => {
        obj.viewType[k] = FilterMeta.toJSON(v);
      });
    }
    obj.poolType = {};
    if (message.poolType) {
      Object.entries(message.poolType).forEach(([k, v]) => {
        obj.poolType[k] = FilterMeta.toJSON(v);
      });
    }
    obj.exterior = {};
    if (message.exterior) {
      Object.entries(message.exterior).forEach(([k, v]) => {
        obj.exterior[k] = FilterMeta.toJSON(v);
      });
    }
    obj.hotelCategory = {};
    if (message.hotelCategory) {
      Object.entries(message.hotelCategory).forEach(([k, v]) => {
        obj.hotelCategory[k] = FilterMeta.toJSON(v);
      });
    }
    obj.rating = {};
    if (message.rating) {
      Object.entries(message.rating).forEach(([k, v]) => {
        obj.rating[k] = FilterMeta.toJSON(v);
      });
    }
    obj.accommodationCategory = {};
    if (message.accommodationCategory) {
      Object.entries(message.accommodationCategory).forEach(([k, v]) => {
        obj.accommodationCategory[k] = FilterMeta.toJSON(v);
      });
    }
    obj.attributes = {};
    if (message.attributes) {
      Object.entries(message.attributes).forEach(([k, v]) => {
        obj.attributes[k] = FilterMeta.toJSON(v);
      });
    }
    return obj;
  },

  fromPartial(object: DeepPartial<AccommodationMeta>): AccommodationMeta {
    const message = createBaseAccommodationMeta();
    message.mealType = Object.entries(object.mealType ?? {}).reduce<{
      [key: string]: FilterMeta;
    }>((acc, [key, value]) => {
      if (value !== undefined) {
        acc[key] = FilterMeta.fromPartial(value);
      }
      return acc;
    }, {});
    message.roomType = Object.entries(object.roomType ?? {}).reduce<{
      [key: string]: FilterMeta;
    }>((acc, [key, value]) => {
      if (value !== undefined) {
        acc[key] = FilterMeta.fromPartial(value);
      }
      return acc;
    }, {});
    message.roomClass = Object.entries(object.roomClass ?? {}).reduce<{
      [key: string]: FilterMeta;
    }>((acc, [key, value]) => {
      if (value !== undefined) {
        acc[key] = FilterMeta.fromPartial(value);
      }
      return acc;
    }, {});
    message.viewType = Object.entries(object.viewType ?? {}).reduce<{
      [key: string]: FilterMeta;
    }>((acc, [key, value]) => {
      if (value !== undefined) {
        acc[key] = FilterMeta.fromPartial(value);
      }
      return acc;
    }, {});
    message.poolType = Object.entries(object.poolType ?? {}).reduce<{
      [key: string]: FilterMeta;
    }>((acc, [key, value]) => {
      if (value !== undefined) {
        acc[key] = FilterMeta.fromPartial(value);
      }
      return acc;
    }, {});
    message.exterior = Object.entries(object.exterior ?? {}).reduce<{
      [key: string]: FilterMeta;
    }>((acc, [key, value]) => {
      if (value !== undefined) {
        acc[key] = FilterMeta.fromPartial(value);
      }
      return acc;
    }, {});
    message.hotelCategory = Object.entries(object.hotelCategory ?? {}).reduce<{
      [key: string]: FilterMeta;
    }>((acc, [key, value]) => {
      if (value !== undefined) {
        acc[key] = FilterMeta.fromPartial(value);
      }
      return acc;
    }, {});
    message.rating = Object.entries(object.rating ?? {}).reduce<{
      [key: number]: FilterMeta;
    }>((acc, [key, value]) => {
      if (value !== undefined) {
        acc[Number(key)] = FilterMeta.fromPartial(value);
      }
      return acc;
    }, {});
    message.accommodationCategory = Object.entries(
      object.accommodationCategory ?? {}
    ).reduce<{ [key: string]: FilterMeta }>((acc, [key, value]) => {
      if (value !== undefined) {
        acc[key] = FilterMeta.fromPartial(value);
      }
      return acc;
    }, {});
    message.attributes = Object.entries(object.attributes ?? {}).reduce<{
      [key: string]: FilterMeta;
    }>((acc, [key, value]) => {
      if (value !== undefined) {
        acc[key] = FilterMeta.fromPartial(value);
      }
      return acc;
    }, {});
    return message;
  },
};

function createBaseAccommodationMeta_MealTypeEntry(): AccommodationMeta_MealTypeEntry {
  return { key: "", value: undefined };
}

export const AccommodationMeta_MealTypeEntry = {
  encode(
    message: AccommodationMeta_MealTypeEntry,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      FilterMeta.encode(message.value, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number
  ): AccommodationMeta_MealTypeEntry {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAccommodationMeta_MealTypeEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.key = reader.string();
          break;
        case 2:
          message.value = FilterMeta.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): AccommodationMeta_MealTypeEntry {
    return {
      key: isSet(object.key) ? String(object.key) : "",
      value: isSet(object.value)
        ? FilterMeta.fromJSON(object.value)
        : undefined,
    };
  },

  toJSON(message: AccommodationMeta_MealTypeEntry): unknown {
    const obj: any = {};
    message.key !== undefined && (obj.key = message.key);
    message.value !== undefined &&
      (obj.value = message.value
        ? FilterMeta.toJSON(message.value)
        : undefined);
    return obj;
  },

  fromPartial(
    object: DeepPartial<AccommodationMeta_MealTypeEntry>
  ): AccommodationMeta_MealTypeEntry {
    const message = createBaseAccommodationMeta_MealTypeEntry();
    message.key = object.key ?? "";
    message.value =
      object.value !== undefined && object.value !== null
        ? FilterMeta.fromPartial(object.value)
        : undefined;
    return message;
  },
};

function createBaseAccommodationMeta_RoomTypeEntry(): AccommodationMeta_RoomTypeEntry {
  return { key: "", value: undefined };
}

export const AccommodationMeta_RoomTypeEntry = {
  encode(
    message: AccommodationMeta_RoomTypeEntry,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      FilterMeta.encode(message.value, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number
  ): AccommodationMeta_RoomTypeEntry {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAccommodationMeta_RoomTypeEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.key = reader.string();
          break;
        case 2:
          message.value = FilterMeta.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): AccommodationMeta_RoomTypeEntry {
    return {
      key: isSet(object.key) ? String(object.key) : "",
      value: isSet(object.value)
        ? FilterMeta.fromJSON(object.value)
        : undefined,
    };
  },

  toJSON(message: AccommodationMeta_RoomTypeEntry): unknown {
    const obj: any = {};
    message.key !== undefined && (obj.key = message.key);
    message.value !== undefined &&
      (obj.value = message.value
        ? FilterMeta.toJSON(message.value)
        : undefined);
    return obj;
  },

  fromPartial(
    object: DeepPartial<AccommodationMeta_RoomTypeEntry>
  ): AccommodationMeta_RoomTypeEntry {
    const message = createBaseAccommodationMeta_RoomTypeEntry();
    message.key = object.key ?? "";
    message.value =
      object.value !== undefined && object.value !== null
        ? FilterMeta.fromPartial(object.value)
        : undefined;
    return message;
  },
};

function createBaseAccommodationMeta_RoomClassEntry(): AccommodationMeta_RoomClassEntry {
  return { key: "", value: undefined };
}

export const AccommodationMeta_RoomClassEntry = {
  encode(
    message: AccommodationMeta_RoomClassEntry,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      FilterMeta.encode(message.value, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number
  ): AccommodationMeta_RoomClassEntry {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAccommodationMeta_RoomClassEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.key = reader.string();
          break;
        case 2:
          message.value = FilterMeta.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): AccommodationMeta_RoomClassEntry {
    return {
      key: isSet(object.key) ? String(object.key) : "",
      value: isSet(object.value)
        ? FilterMeta.fromJSON(object.value)
        : undefined,
    };
  },

  toJSON(message: AccommodationMeta_RoomClassEntry): unknown {
    const obj: any = {};
    message.key !== undefined && (obj.key = message.key);
    message.value !== undefined &&
      (obj.value = message.value
        ? FilterMeta.toJSON(message.value)
        : undefined);
    return obj;
  },

  fromPartial(
    object: DeepPartial<AccommodationMeta_RoomClassEntry>
  ): AccommodationMeta_RoomClassEntry {
    const message = createBaseAccommodationMeta_RoomClassEntry();
    message.key = object.key ?? "";
    message.value =
      object.value !== undefined && object.value !== null
        ? FilterMeta.fromPartial(object.value)
        : undefined;
    return message;
  },
};

function createBaseAccommodationMeta_ViewTypeEntry(): AccommodationMeta_ViewTypeEntry {
  return { key: "", value: undefined };
}

export const AccommodationMeta_ViewTypeEntry = {
  encode(
    message: AccommodationMeta_ViewTypeEntry,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      FilterMeta.encode(message.value, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number
  ): AccommodationMeta_ViewTypeEntry {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAccommodationMeta_ViewTypeEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.key = reader.string();
          break;
        case 2:
          message.value = FilterMeta.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): AccommodationMeta_ViewTypeEntry {
    return {
      key: isSet(object.key) ? String(object.key) : "",
      value: isSet(object.value)
        ? FilterMeta.fromJSON(object.value)
        : undefined,
    };
  },

  toJSON(message: AccommodationMeta_ViewTypeEntry): unknown {
    const obj: any = {};
    message.key !== undefined && (obj.key = message.key);
    message.value !== undefined &&
      (obj.value = message.value
        ? FilterMeta.toJSON(message.value)
        : undefined);
    return obj;
  },

  fromPartial(
    object: DeepPartial<AccommodationMeta_ViewTypeEntry>
  ): AccommodationMeta_ViewTypeEntry {
    const message = createBaseAccommodationMeta_ViewTypeEntry();
    message.key = object.key ?? "";
    message.value =
      object.value !== undefined && object.value !== null
        ? FilterMeta.fromPartial(object.value)
        : undefined;
    return message;
  },
};

function createBaseAccommodationMeta_PoolTypeEntry(): AccommodationMeta_PoolTypeEntry {
  return { key: "", value: undefined };
}

export const AccommodationMeta_PoolTypeEntry = {
  encode(
    message: AccommodationMeta_PoolTypeEntry,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      FilterMeta.encode(message.value, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number
  ): AccommodationMeta_PoolTypeEntry {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAccommodationMeta_PoolTypeEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.key = reader.string();
          break;
        case 2:
          message.value = FilterMeta.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): AccommodationMeta_PoolTypeEntry {
    return {
      key: isSet(object.key) ? String(object.key) : "",
      value: isSet(object.value)
        ? FilterMeta.fromJSON(object.value)
        : undefined,
    };
  },

  toJSON(message: AccommodationMeta_PoolTypeEntry): unknown {
    const obj: any = {};
    message.key !== undefined && (obj.key = message.key);
    message.value !== undefined &&
      (obj.value = message.value
        ? FilterMeta.toJSON(message.value)
        : undefined);
    return obj;
  },

  fromPartial(
    object: DeepPartial<AccommodationMeta_PoolTypeEntry>
  ): AccommodationMeta_PoolTypeEntry {
    const message = createBaseAccommodationMeta_PoolTypeEntry();
    message.key = object.key ?? "";
    message.value =
      object.value !== undefined && object.value !== null
        ? FilterMeta.fromPartial(object.value)
        : undefined;
    return message;
  },
};

function createBaseAccommodationMeta_ExteriorEntry(): AccommodationMeta_ExteriorEntry {
  return { key: "", value: undefined };
}

export const AccommodationMeta_ExteriorEntry = {
  encode(
    message: AccommodationMeta_ExteriorEntry,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      FilterMeta.encode(message.value, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number
  ): AccommodationMeta_ExteriorEntry {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAccommodationMeta_ExteriorEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.key = reader.string();
          break;
        case 2:
          message.value = FilterMeta.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): AccommodationMeta_ExteriorEntry {
    return {
      key: isSet(object.key) ? String(object.key) : "",
      value: isSet(object.value)
        ? FilterMeta.fromJSON(object.value)
        : undefined,
    };
  },

  toJSON(message: AccommodationMeta_ExteriorEntry): unknown {
    const obj: any = {};
    message.key !== undefined && (obj.key = message.key);
    message.value !== undefined &&
      (obj.value = message.value
        ? FilterMeta.toJSON(message.value)
        : undefined);
    return obj;
  },

  fromPartial(
    object: DeepPartial<AccommodationMeta_ExteriorEntry>
  ): AccommodationMeta_ExteriorEntry {
    const message = createBaseAccommodationMeta_ExteriorEntry();
    message.key = object.key ?? "";
    message.value =
      object.value !== undefined && object.value !== null
        ? FilterMeta.fromPartial(object.value)
        : undefined;
    return message;
  },
};

function createBaseAccommodationMeta_HotelCategoryEntry(): AccommodationMeta_HotelCategoryEntry {
  return { key: "", value: undefined };
}

export const AccommodationMeta_HotelCategoryEntry = {
  encode(
    message: AccommodationMeta_HotelCategoryEntry,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      FilterMeta.encode(message.value, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number
  ): AccommodationMeta_HotelCategoryEntry {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAccommodationMeta_HotelCategoryEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.key = reader.string();
          break;
        case 2:
          message.value = FilterMeta.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): AccommodationMeta_HotelCategoryEntry {
    return {
      key: isSet(object.key) ? String(object.key) : "",
      value: isSet(object.value)
        ? FilterMeta.fromJSON(object.value)
        : undefined,
    };
  },

  toJSON(message: AccommodationMeta_HotelCategoryEntry): unknown {
    const obj: any = {};
    message.key !== undefined && (obj.key = message.key);
    message.value !== undefined &&
      (obj.value = message.value
        ? FilterMeta.toJSON(message.value)
        : undefined);
    return obj;
  },

  fromPartial(
    object: DeepPartial<AccommodationMeta_HotelCategoryEntry>
  ): AccommodationMeta_HotelCategoryEntry {
    const message = createBaseAccommodationMeta_HotelCategoryEntry();
    message.key = object.key ?? "";
    message.value =
      object.value !== undefined && object.value !== null
        ? FilterMeta.fromPartial(object.value)
        : undefined;
    return message;
  },
};

function createBaseAccommodationMeta_RatingEntry(): AccommodationMeta_RatingEntry {
  return { key: 0, value: undefined };
}

export const AccommodationMeta_RatingEntry = {
  encode(
    message: AccommodationMeta_RatingEntry,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.key !== 0) {
      writer.uint32(8).uint32(message.key);
    }
    if (message.value !== undefined) {
      FilterMeta.encode(message.value, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number
  ): AccommodationMeta_RatingEntry {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAccommodationMeta_RatingEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.key = reader.uint32();
          break;
        case 2:
          message.value = FilterMeta.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): AccommodationMeta_RatingEntry {
    return {
      key: isSet(object.key) ? Number(object.key) : 0,
      value: isSet(object.value)
        ? FilterMeta.fromJSON(object.value)
        : undefined,
    };
  },

  toJSON(message: AccommodationMeta_RatingEntry): unknown {
    const obj: any = {};
    message.key !== undefined && (obj.key = Math.round(message.key));
    message.value !== undefined &&
      (obj.value = message.value
        ? FilterMeta.toJSON(message.value)
        : undefined);
    return obj;
  },

  fromPartial(
    object: DeepPartial<AccommodationMeta_RatingEntry>
  ): AccommodationMeta_RatingEntry {
    const message = createBaseAccommodationMeta_RatingEntry();
    message.key = object.key ?? 0;
    message.value =
      object.value !== undefined && object.value !== null
        ? FilterMeta.fromPartial(object.value)
        : undefined;
    return message;
  },
};

function createBaseAccommodationMeta_AccommodationCategoryEntry(): AccommodationMeta_AccommodationCategoryEntry {
  return { key: "", value: undefined };
}

export const AccommodationMeta_AccommodationCategoryEntry = {
  encode(
    message: AccommodationMeta_AccommodationCategoryEntry,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      FilterMeta.encode(message.value, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number
  ): AccommodationMeta_AccommodationCategoryEntry {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAccommodationMeta_AccommodationCategoryEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.key = reader.string();
          break;
        case 2:
          message.value = FilterMeta.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): AccommodationMeta_AccommodationCategoryEntry {
    return {
      key: isSet(object.key) ? String(object.key) : "",
      value: isSet(object.value)
        ? FilterMeta.fromJSON(object.value)
        : undefined,
    };
  },

  toJSON(message: AccommodationMeta_AccommodationCategoryEntry): unknown {
    const obj: any = {};
    message.key !== undefined && (obj.key = message.key);
    message.value !== undefined &&
      (obj.value = message.value
        ? FilterMeta.toJSON(message.value)
        : undefined);
    return obj;
  },

  fromPartial(
    object: DeepPartial<AccommodationMeta_AccommodationCategoryEntry>
  ): AccommodationMeta_AccommodationCategoryEntry {
    const message = createBaseAccommodationMeta_AccommodationCategoryEntry();
    message.key = object.key ?? "";
    message.value =
      object.value !== undefined && object.value !== null
        ? FilterMeta.fromPartial(object.value)
        : undefined;
    return message;
  },
};

function createBaseAccommodationMeta_AttributesEntry(): AccommodationMeta_AttributesEntry {
  return { key: "", value: undefined };
}

export const AccommodationMeta_AttributesEntry = {
  encode(
    message: AccommodationMeta_AttributesEntry,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      FilterMeta.encode(message.value, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number
  ): AccommodationMeta_AttributesEntry {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAccommodationMeta_AttributesEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.key = reader.string();
          break;
        case 2:
          message.value = FilterMeta.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): AccommodationMeta_AttributesEntry {
    return {
      key: isSet(object.key) ? String(object.key) : "",
      value: isSet(object.value)
        ? FilterMeta.fromJSON(object.value)
        : undefined,
    };
  },

  toJSON(message: AccommodationMeta_AttributesEntry): unknown {
    const obj: any = {};
    message.key !== undefined && (obj.key = message.key);
    message.value !== undefined &&
      (obj.value = message.value
        ? FilterMeta.toJSON(message.value)
        : undefined);
    return obj;
  },

  fromPartial(
    object: DeepPartial<AccommodationMeta_AttributesEntry>
  ): AccommodationMeta_AttributesEntry {
    const message = createBaseAccommodationMeta_AttributesEntry();
    message.key = object.key ?? "";
    message.value =
      object.value !== undefined && object.value !== null
        ? FilterMeta.fromPartial(object.value)
        : undefined;
    return message;
  },
};

function createBaseCancellationMeta(): CancellationMeta {
  return { free: undefined, cost: undefined, free24Hour: undefined };
}

export const CancellationMeta = {
  encode(
    message: CancellationMeta,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.free !== undefined) {
      FilterMeta.encode(message.free, writer.uint32(10).fork()).ldelim();
    }
    if (message.cost !== undefined) {
      FilterMeta.encode(message.cost, writer.uint32(18).fork()).ldelim();
    }
    if (message.free24Hour !== undefined) {
      FilterMeta.encode(message.free24Hour, writer.uint32(26).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): CancellationMeta {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCancellationMeta();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.free = FilterMeta.decode(reader, reader.uint32());
          break;
        case 2:
          message.cost = FilterMeta.decode(reader, reader.uint32());
          break;
        case 3:
          message.free24Hour = FilterMeta.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): CancellationMeta {
    return {
      free: isSet(object.free) ? FilterMeta.fromJSON(object.free) : undefined,
      cost: isSet(object.cost) ? FilterMeta.fromJSON(object.cost) : undefined,
      free24Hour: isSet(object.free24Hour)
        ? FilterMeta.fromJSON(object.free24Hour)
        : undefined,
    };
  },

  toJSON(message: CancellationMeta): unknown {
    const obj: any = {};
    message.free !== undefined &&
      (obj.free = message.free ? FilterMeta.toJSON(message.free) : undefined);
    message.cost !== undefined &&
      (obj.cost = message.cost ? FilterMeta.toJSON(message.cost) : undefined);
    message.free24Hour !== undefined &&
      (obj.free24Hour = message.free24Hour
        ? FilterMeta.toJSON(message.free24Hour)
        : undefined);
    return obj;
  },

  fromPartial(object: DeepPartial<CancellationMeta>): CancellationMeta {
    const message = createBaseCancellationMeta();
    message.free =
      object.free !== undefined && object.free !== null
        ? FilterMeta.fromPartial(object.free)
        : undefined;
    message.cost =
      object.cost !== undefined && object.cost !== null
        ? FilterMeta.fromPartial(object.cost)
        : undefined;
    message.free24Hour =
      object.free24Hour !== undefined && object.free24Hour !== null
        ? FilterMeta.fromPartial(object.free24Hour)
        : undefined;
    return message;
  },
};

function createBaseSpecialMeta(): SpecialMeta {
  return {
    cancellation: undefined,
    rebookable: undefined,
    reservable: undefined,
    lowDeposit: undefined,
    promoDiscount: undefined,
  };
}

export const SpecialMeta = {
  encode(
    message: SpecialMeta,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.cancellation !== undefined) {
      CancellationMeta.encode(
        message.cancellation,
        writer.uint32(10).fork()
      ).ldelim();
    }
    if (message.rebookable !== undefined) {
      FilterMeta.encode(message.rebookable, writer.uint32(18).fork()).ldelim();
    }
    if (message.reservable !== undefined) {
      FilterMeta.encode(message.reservable, writer.uint32(26).fork()).ldelim();
    }
    if (message.lowDeposit !== undefined) {
      FilterMeta.encode(message.lowDeposit, writer.uint32(34).fork()).ldelim();
    }
    if (message.promoDiscount !== undefined) {
      FilterMeta.encode(
        message.promoDiscount,
        writer.uint32(50).fork()
      ).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SpecialMeta {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpecialMeta();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.cancellation = CancellationMeta.decode(
            reader,
            reader.uint32()
          );
          break;
        case 2:
          message.rebookable = FilterMeta.decode(reader, reader.uint32());
          break;
        case 3:
          message.reservable = FilterMeta.decode(reader, reader.uint32());
          break;
        case 4:
          message.lowDeposit = FilterMeta.decode(reader, reader.uint32());
          break;
        case 6:
          message.promoDiscount = FilterMeta.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): SpecialMeta {
    return {
      cancellation: isSet(object.cancellation)
        ? CancellationMeta.fromJSON(object.cancellation)
        : undefined,
      rebookable: isSet(object.rebookable)
        ? FilterMeta.fromJSON(object.rebookable)
        : undefined,
      reservable: isSet(object.reservable)
        ? FilterMeta.fromJSON(object.reservable)
        : undefined,
      lowDeposit: isSet(object.lowDeposit)
        ? FilterMeta.fromJSON(object.lowDeposit)
        : undefined,
      promoDiscount: isSet(object.promoDiscount)
        ? FilterMeta.fromJSON(object.promoDiscount)
        : undefined,
    };
  },

  toJSON(message: SpecialMeta): unknown {
    const obj: any = {};
    message.cancellation !== undefined &&
      (obj.cancellation = message.cancellation
        ? CancellationMeta.toJSON(message.cancellation)
        : undefined);
    message.rebookable !== undefined &&
      (obj.rebookable = message.rebookable
        ? FilterMeta.toJSON(message.rebookable)
        : undefined);
    message.reservable !== undefined &&
      (obj.reservable = message.reservable
        ? FilterMeta.toJSON(message.reservable)
        : undefined);
    message.lowDeposit !== undefined &&
      (obj.lowDeposit = message.lowDeposit
        ? FilterMeta.toJSON(message.lowDeposit)
        : undefined);
    message.promoDiscount !== undefined &&
      (obj.promoDiscount = message.promoDiscount
        ? FilterMeta.toJSON(message.promoDiscount)
        : undefined);
    return obj;
  },

  fromPartial(object: DeepPartial<SpecialMeta>): SpecialMeta {
    const message = createBaseSpecialMeta();
    message.cancellation =
      object.cancellation !== undefined && object.cancellation !== null
        ? CancellationMeta.fromPartial(object.cancellation)
        : undefined;
    message.rebookable =
      object.rebookable !== undefined && object.rebookable !== null
        ? FilterMeta.fromPartial(object.rebookable)
        : undefined;
    message.reservable =
      object.reservable !== undefined && object.reservable !== null
        ? FilterMeta.fromPartial(object.reservable)
        : undefined;
    message.lowDeposit =
      object.lowDeposit !== undefined && object.lowDeposit !== null
        ? FilterMeta.fromPartial(object.lowDeposit)
        : undefined;
    message.promoDiscount =
      object.promoDiscount !== undefined && object.promoDiscount !== null
        ? FilterMeta.fromPartial(object.promoDiscount)
        : undefined;
    return message;
  },
};

function createBaseFilterInformation(): FilterInformation {
  return {
    priceRange: undefined,
    tourOperator: undefined,
    flight: undefined,
    transfer: undefined,
    accommodation: undefined,
    special: undefined,
    popularFilterList: [],
    tourOperatorCategory: {},
    paymentType: {},
  };
}

export const FilterInformation = {
  encode(
    message: FilterInformation,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.priceRange !== undefined) {
      PriceRange.encode(message.priceRange, writer.uint32(10).fork()).ldelim();
    }
    if (message.tourOperator !== undefined) {
      TourOperatorFilterList.encode(
        message.tourOperator,
        writer.uint32(18).fork()
      ).ldelim();
    }
    if (message.flight !== undefined) {
      FlightMeta.encode(message.flight, writer.uint32(34).fork()).ldelim();
    }
    if (message.transfer !== undefined) {
      TransferMeta.encode(message.transfer, writer.uint32(42).fork()).ldelim();
    }
    if (message.accommodation !== undefined) {
      AccommodationMeta.encode(
        message.accommodation,
        writer.uint32(58).fork()
      ).ldelim();
    }
    if (message.special !== undefined) {
      SpecialMeta.encode(message.special, writer.uint32(66).fork()).ldelim();
    }
    for (const v of message.popularFilterList) {
      PopularFilter.encode(v!, writer.uint32(74).fork()).ldelim();
    }
    Object.entries(message.tourOperatorCategory).forEach(([key, value]) => {
      FilterInformation_TourOperatorCategoryEntry.encode(
        { key: key as any, value },
        writer.uint32(26).fork()
      ).ldelim();
    });
    Object.entries(message.paymentType).forEach(([key, value]) => {
      FilterInformation_PaymentTypeEntry.encode(
        { key: key as any, value },
        writer.uint32(50).fork()
      ).ldelim();
    });
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): FilterInformation {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFilterInformation();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.priceRange = PriceRange.decode(reader, reader.uint32());
          break;
        case 2:
          message.tourOperator = TourOperatorFilterList.decode(
            reader,
            reader.uint32()
          );
          break;
        case 4:
          message.flight = FlightMeta.decode(reader, reader.uint32());
          break;
        case 5:
          message.transfer = TransferMeta.decode(reader, reader.uint32());
          break;
        case 7:
          message.accommodation = AccommodationMeta.decode(
            reader,
            reader.uint32()
          );
          break;
        case 8:
          message.special = SpecialMeta.decode(reader, reader.uint32());
          break;
        case 9:
          message.popularFilterList.push(
            PopularFilter.decode(reader, reader.uint32())
          );
          break;
        case 3:
          const entry3 = FilterInformation_TourOperatorCategoryEntry.decode(
            reader,
            reader.uint32()
          );
          if (entry3.value !== undefined) {
            message.tourOperatorCategory[entry3.key] = entry3.value;
          }
          break;
        case 6:
          const entry6 = FilterInformation_PaymentTypeEntry.decode(
            reader,
            reader.uint32()
          );
          if (entry6.value !== undefined) {
            message.paymentType[entry6.key] = entry6.value;
          }
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): FilterInformation {
    return {
      priceRange: isSet(object.priceRange)
        ? PriceRange.fromJSON(object.priceRange)
        : undefined,
      tourOperator: isSet(object.tourOperator)
        ? TourOperatorFilterList.fromJSON(object.tourOperator)
        : undefined,
      flight: isSet(object.flight)
        ? FlightMeta.fromJSON(object.flight)
        : undefined,
      transfer: isSet(object.transfer)
        ? TransferMeta.fromJSON(object.transfer)
        : undefined,
      accommodation: isSet(object.accommodation)
        ? AccommodationMeta.fromJSON(object.accommodation)
        : undefined,
      special: isSet(object.special)
        ? SpecialMeta.fromJSON(object.special)
        : undefined,
      popularFilterList: Array.isArray(object?.popularFilterList)
        ? object.popularFilterList.map((e: any) => PopularFilter.fromJSON(e))
        : [],
      tourOperatorCategory: isObject(object.tourOperatorCategory)
        ? Object.entries(object.tourOperatorCategory).reduce<{
            [key: string]: FilterMeta;
          }>((acc, [key, value]) => {
            acc[key] = FilterMeta.fromJSON(value);
            return acc;
          }, {})
        : {},
      paymentType: isObject(object.paymentType)
        ? Object.entries(object.paymentType).reduce<{
            [key: string]: FilterMeta;
          }>((acc, [key, value]) => {
            acc[key] = FilterMeta.fromJSON(value);
            return acc;
          }, {})
        : {},
    };
  },

  toJSON(message: FilterInformation): unknown {
    const obj: any = {};
    message.priceRange !== undefined &&
      (obj.priceRange = message.priceRange
        ? PriceRange.toJSON(message.priceRange)
        : undefined);
    message.tourOperator !== undefined &&
      (obj.tourOperator = message.tourOperator
        ? TourOperatorFilterList.toJSON(message.tourOperator)
        : undefined);
    message.flight !== undefined &&
      (obj.flight = message.flight
        ? FlightMeta.toJSON(message.flight)
        : undefined);
    message.transfer !== undefined &&
      (obj.transfer = message.transfer
        ? TransferMeta.toJSON(message.transfer)
        : undefined);
    message.accommodation !== undefined &&
      (obj.accommodation = message.accommodation
        ? AccommodationMeta.toJSON(message.accommodation)
        : undefined);
    message.special !== undefined &&
      (obj.special = message.special
        ? SpecialMeta.toJSON(message.special)
        : undefined);
    if (message.popularFilterList) {
      obj.popularFilterList = message.popularFilterList.map((e) =>
        e ? PopularFilter.toJSON(e) : undefined
      );
    } else {
      obj.popularFilterList = [];
    }
    obj.tourOperatorCategory = {};
    if (message.tourOperatorCategory) {
      Object.entries(message.tourOperatorCategory).forEach(([k, v]) => {
        obj.tourOperatorCategory[k] = FilterMeta.toJSON(v);
      });
    }
    obj.paymentType = {};
    if (message.paymentType) {
      Object.entries(message.paymentType).forEach(([k, v]) => {
        obj.paymentType[k] = FilterMeta.toJSON(v);
      });
    }
    return obj;
  },

  fromPartial(object: DeepPartial<FilterInformation>): FilterInformation {
    const message = createBaseFilterInformation();
    message.priceRange =
      object.priceRange !== undefined && object.priceRange !== null
        ? PriceRange.fromPartial(object.priceRange)
        : undefined;
    message.tourOperator =
      object.tourOperator !== undefined && object.tourOperator !== null
        ? TourOperatorFilterList.fromPartial(object.tourOperator)
        : undefined;
    message.flight =
      object.flight !== undefined && object.flight !== null
        ? FlightMeta.fromPartial(object.flight)
        : undefined;
    message.transfer =
      object.transfer !== undefined && object.transfer !== null
        ? TransferMeta.fromPartial(object.transfer)
        : undefined;
    message.accommodation =
      object.accommodation !== undefined && object.accommodation !== null
        ? AccommodationMeta.fromPartial(object.accommodation)
        : undefined;
    message.special =
      object.special !== undefined && object.special !== null
        ? SpecialMeta.fromPartial(object.special)
        : undefined;
    message.popularFilterList =
      object.popularFilterList?.map((e) => PopularFilter.fromPartial(e)) || [];
    message.tourOperatorCategory = Object.entries(
      object.tourOperatorCategory ?? {}
    ).reduce<{ [key: string]: FilterMeta }>((acc, [key, value]) => {
      if (value !== undefined) {
        acc[key] = FilterMeta.fromPartial(value);
      }
      return acc;
    }, {});
    message.paymentType = Object.entries(object.paymentType ?? {}).reduce<{
      [key: string]: FilterMeta;
    }>((acc, [key, value]) => {
      if (value !== undefined) {
        acc[key] = FilterMeta.fromPartial(value);
      }
      return acc;
    }, {});
    return message;
  },
};

function createBaseFilterInformation_TourOperatorCategoryEntry(): FilterInformation_TourOperatorCategoryEntry {
  return { key: "", value: undefined };
}

export const FilterInformation_TourOperatorCategoryEntry = {
  encode(
    message: FilterInformation_TourOperatorCategoryEntry,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      FilterMeta.encode(message.value, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number
  ): FilterInformation_TourOperatorCategoryEntry {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFilterInformation_TourOperatorCategoryEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.key = reader.string();
          break;
        case 2:
          message.value = FilterMeta.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): FilterInformation_TourOperatorCategoryEntry {
    return {
      key: isSet(object.key) ? String(object.key) : "",
      value: isSet(object.value)
        ? FilterMeta.fromJSON(object.value)
        : undefined,
    };
  },

  toJSON(message: FilterInformation_TourOperatorCategoryEntry): unknown {
    const obj: any = {};
    message.key !== undefined && (obj.key = message.key);
    message.value !== undefined &&
      (obj.value = message.value
        ? FilterMeta.toJSON(message.value)
        : undefined);
    return obj;
  },

  fromPartial(
    object: DeepPartial<FilterInformation_TourOperatorCategoryEntry>
  ): FilterInformation_TourOperatorCategoryEntry {
    const message = createBaseFilterInformation_TourOperatorCategoryEntry();
    message.key = object.key ?? "";
    message.value =
      object.value !== undefined && object.value !== null
        ? FilterMeta.fromPartial(object.value)
        : undefined;
    return message;
  },
};

function createBaseFilterInformation_PaymentTypeEntry(): FilterInformation_PaymentTypeEntry {
  return { key: "", value: undefined };
}

export const FilterInformation_PaymentTypeEntry = {
  encode(
    message: FilterInformation_PaymentTypeEntry,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      FilterMeta.encode(message.value, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number
  ): FilterInformation_PaymentTypeEntry {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFilterInformation_PaymentTypeEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.key = reader.string();
          break;
        case 2:
          message.value = FilterMeta.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): FilterInformation_PaymentTypeEntry {
    return {
      key: isSet(object.key) ? String(object.key) : "",
      value: isSet(object.value)
        ? FilterMeta.fromJSON(object.value)
        : undefined,
    };
  },

  toJSON(message: FilterInformation_PaymentTypeEntry): unknown {
    const obj: any = {};
    message.key !== undefined && (obj.key = message.key);
    message.value !== undefined &&
      (obj.value = message.value
        ? FilterMeta.toJSON(message.value)
        : undefined);
    return obj;
  },

  fromPartial(
    object: DeepPartial<FilterInformation_PaymentTypeEntry>
  ): FilterInformation_PaymentTypeEntry {
    const message = createBaseFilterInformation_PaymentTypeEntry();
    message.key = object.key ?? "";
    message.value =
      object.value !== undefined && object.value !== null
        ? FilterMeta.fromPartial(object.value)
        : undefined;
    return message;
  },
};

type Builtin =
  | Date
  | Function
  | Uint8Array
  | string
  | number
  | boolean
  | undefined;

type DeepPartial<T> = T extends Builtin
  ? T
  : T extends Array<infer U>
  ? Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U>
  ? ReadonlyArray<DeepPartial<U>>
  : T extends {}
  ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
